jQuery(function ($) {
  function scrollToNextSection(trigger) {
    var target = $(trigger)
      .closest(".hero-banner")
      .nextAll("section")
      .first();

    if (!target.length) {
      return;
    }

    window.acronScrollTo(target.get(0));
  }

  $(".hero-banner__arrow-down").on("click", function (e) {
    e.preventDefault();
    scrollToNextSection(this);
  });

  $('.hero-banner__cta a[href="#"]').on("click", function (e) {
    e.preventDefault();
    scrollToNextSection(this);
  });

  $(document)
    .on("lity:ready", ".hero-banner__video-popup", function () {
      var video = $(this).find("video").get(0);

      if (video) {
        var playPromise = video.play();

        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      }
    })
    .on("lity:remove", ".hero-banner__video-popup", function () {
      var video = $(this).find("video").get(0);

      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
});
